<template>
  <div class="overlay-wrapper">
    <form class="form-inline">
      <h3 v-text="title" /> <span class="text-gray margin-left margin-right divider">|</span>
      <c-select
        v-if="Object.keys(monthsFormated).length"
        v-model="month"
        title="ДАННЫЕ ЗА ПЕРИОД:"
        form-group
        :options="monthsFormated"
      />
    </form>
    <hr>
    <slot
      :diagram="getMetrics(metrics).diagram || []"
      :table="getMetrics(metrics).table || []"
    />
    <c-loading-overlay v-if="isMetricsLoading(metrics)" />
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapState } from 'vuex'
import constants from '../../../../../../../resources/js/constants'
import CLoadingOverlay from '../../../../../../../resources/js/components/ui/CLoadingOverlay'
import { getMonthsFormated } from '../../../../../../../resources/js/helper'
import CSelect from '../../../../../../../resources/js/components/ui/CSelect'

const MONTH_DATE_FORMAT = 'YYYY-MM-DD'

export default {
  name: 'Metrics',
  components: {
    CLoadingOverlay,
    CSelect
  },
  props: {
    /**
     * Заголовок.
     */
    title: {
      type: String,
      required: true
    },
    /**
     * Тип метрики.
     *
     * @values geo, targets, devices, sources
     */
    metrics: {
      validator (value) {
        return [
          constants.METRICS_GEO,
          constants.METRICS_TARGETS,
          constants.METRICS_DEVICES,
          constants.METRICS_SOURCES
        ].includes(value)
      },
      required: true
    },
    /**
     * Вид трафика YM (y) или GA (g).
     *
     * @values y, g
     */
    type: {
      validator (value) {
        return [constants.SENGINE_YANDEX, constants.SENGINE_GOOGLE].includes(value)
      },
      required: true
    }
  },
  data () {
    return {
      month: moment().subtract(1, 'months').startOf('month').format(MONTH_DATE_FORMAT)
    }
  },
  computed: {
    /**
     * Элементы выпадающего списка с выбором периода (месяца).
     *
     * @returns {{}}
     */
    monthsFormated () {
      let dates = {}

      if (this.clientProjects.length) {
        dates = getMonthsFormated(this.clientProjects[0].work_start_date, moment().subtract(1, 'month'))
      }
      // if (this.$store.state.seo.client.projects.selectedProjectId) {
      //   dates = getMonthsFormated(this.getSelectedProject.work_start_date, moment().subtract(1, 'month'))
      // }

      return dates
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      clientProjects: state => state.seo.client.projects.projects
    }),
    ...mapGetters({
      getMetrics: 'seo/project/traffic/metrics/getMetrics',
      isMetricsLoading: 'seo/project/traffic/metrics/isLoading',
      getSelectedProject: 'seo/client/projects/getSelectedProject'
    })
  },
  watch: {
    month () {
      this.fetch()
    },
    type () {
      this.fetch()
    }
  },
  mounted () {
    if (this.domainSelected) {
      this.fetch()
    }

    this.$root.$on('clientDomainsSelectedChange', this.fetch)
  },
  destroyed () {
    this.$root.$off('clientDomainsSelectedChange', this.fetch)
  },
  methods: {
    /**
     * Загружает данные метрики.
     */
    fetch () {
      this.fetchProjectTrafficMetrics({
        domain: this.domainSelected,
        from: this.month,
        to: moment(this.month).endOf('month'),
        type: this.type,
        metrics: this.metrics
      })
    },
    ...mapActions({
      fetchProjectTrafficMetrics: 'seo/project/traffic/metrics/fetch'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

h3 {
  display: inline-block;
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 18px;

  @media (max-width: $smBreakpoint) {
    display: block;
    margin-bottom: 15px;
  }
}

.divider {
  @media (max-width: $smBreakpoint) {
    display: none;
  }
}
</style>
